import type { CssVarsThemeOptions, Theme } from '@mui/joy/styles';

// The app's changes to Joy's default theme, shared by both apps' `extendTheme`.

// One blue for every solid primary action, in both schemes: Joy's lighter
// primary-400, a step darker on hover and two when pressed. The dashboard's
// `--dash-blue` and the explorer toolbar read these tokens rather than naming
// a shade, so this is the one place the blue is chosen.
const primaryActions = {
  solidBg: 'var(--joy-palette-primary-400)',
  solidHoverBg: 'var(--joy-palette-primary-500)',
  solidActiveBg: 'var(--joy-palette-primary-600)',
};

// Joy's dark `background.body` and `background.popup` are pure black. Lift
// the page to neutral-900 (the surface colour) and popups to neutral-800. No
// lighter for the page: soft and plain-hover backgrounds are neutral-800, so
// chips and hovered buttons would vanish into it. Inside popups, which are
// now that colour themselves, hover steps up to neutral-700 for the same reason.
const popupHover = ({ theme }: { theme: Theme }) => ({
  [theme.getColorSchemeSelector('dark')]: {
    '--joy-palette-neutral-plainHoverBg': 'var(--joy-palette-neutral-700)',
  },
});

/** Spread into both apps' `extendTheme`. */
export const appThemeOptions: Pick<
  CssVarsThemeOptions,
  'colorSchemes' | 'components'
> = {
  colorSchemes: {
    light: {
      palette: { primary: primaryActions },
    },
    dark: {
      palette: {
        primary: primaryActions,
        background: {
          body: 'var(--joy-palette-neutral-900)',
          popup: 'var(--joy-palette-neutral-800)',
        },
      },
    },
  },
  components: {
    JoyMenu: { styleOverrides: { root: popupHover } },
    JoySelect: { styleOverrides: { listbox: popupHover } },
    JoyAutocomplete: { styleOverrides: { listbox: popupHover } },
  },
};
